import React from "react";

const Bar = ({ content, percent }) => {
 
  const parseContent = (text) => {
    const regex = /(\d+%?)/g; // Matches numbers and percentages
    const parts = text.split(regex); 

    return parts.map((part, index) =>
      regex.test(part) ? <b key={index}>{part}</b> : part
    );
  };

  return <><div className="bar-total" /><div className="bar-pct" style={{width:`${percent}%`}} /><div className="bar-text">{parseContent(content)}</div></>;
};

export default Bar
